import { render, staticRenderFns } from "./MiniInfoSection.vue?vue&type=template&id=6fd14b40&scoped=true&"
import script from "./MiniInfoSection.vue?vue&type=script&lang=js&"
export * from "./MiniInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./MiniInfoSection.vue?vue&type=style&index=0&id=6fd14b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd14b40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VContainer,VIcon,VImg,VListItem,VListItemAvatar,VListItemContent,VListItemTitle})
